import { createSlice } from '@reduxjs/toolkit';
import i18n from 'config/localization/i18n';

import { DialogData } from 'types';

export const dialogSlice = createSlice({
  name: 'dialog',
  initialState: {
    data: undefined as DialogData | undefined,
    hide: 0 as number
  },
  reducers: {
    removeDialog: (state) => {
      state.data = undefined;
    },
    setDialogError: (state, action) => {
      const response = action.payload;
      const data = response.data;
      state.data = {
        status: response.status,
        code: data.code,
        title: data.message,
        description: data.description,
      };
    },
  },
});

export const { removeDialog, setDialogError } = dialogSlice.actions;
export default dialogSlice.reducer;
